import React, {useState} from "react";

import useLocationData from "@globals/hooks/useLocationData";

import TransparentButton from "@components/TransparentButton";
import TextareaInput from "@components/forms/inputs/TextareaInput";

import styles from "./SpecialInstructions.scss";

export default function SpecialInstructions({
  locationId,
  specialInstructions,
  onDataSubmit,
}: {
  locationId: number;
  specialInstructions: string;
  onDataSubmit: (value: string) => void;
}): JSX.Element {
  const [showTextInput, setShowTextInput] = useState<boolean>(false);
  const [value, setValue] = useState<string | undefined>(specialInstructions);
  const location = useLocationData(locationId);

  const handleBlur = () => {
    const trimmedInstructions = value?.trim();

    if (specialInstructions !== trimmedInstructions) {
      onDataSubmit(trimmedInstructions as string);
    }
  };

  if (!location?.can_add_special_order_instructions) {
    return <></>;
  }

  return (
    <div className={styles.specialInstructions}>
      <TransparentButton
        onClick={() => setShowTextInput(!showTextInput)}
        className={styles.instructionsButton}
        aria-label={"Add special instructions"}
      >
        <>Special instructions {showTextInput ? "-" : "+"}</>
      </TransparentButton>
      {showTextInput && (
        <TextareaInput
          value={value}
          data-testid="special-instructions-textarea"
          onBlur={handleBlur}
          onChange={setValue}
          className={styles.textArea}
          name="specialInstructions"
          placeholder="Dressing on the side, hold the onions"
        />
      )}
    </div>
  );
}
